<template>
  <div>
    <vh-dialog
      :visible.sync="dialogVisible"
      :before-close="handleClose"
      :close-on-click-modal="false"
      :title="$t('host.k_574001')"
      :modal="false"
      width="750px"
      custom-class="setting-checked-dialog"
    >
      <div class="data-search" v-show="!noExamData">
        <vh-input
          class="search-dialog-tag"
          v-model.trim="keywordIpt"
          :placeholder="$t('host.k_574002')"
          clearable
          round
          @keyup.enter.native="getExamList(false)"
          style="width: 180px"
          @clear="getExamList"
        >
          <i
            slot="prefix"
            class="vh-icon-search vh-input__icon"
            style="cursor: pointer; line-height: 36px"
            @click="getExamList(false)"
          ></i>
        </vh-input>
      </div>
      <div class="data-base-list" v-show="!noExamData">
        <vh-table
          :data="examList"
          ref="selectExamTable"
          style="width: 100%"
          height="320px"
          class="scrollbar no-border"
          @selection-change="handleSelectionChange"
          @select-all="checkAllExam"
          v-loadMore="moreLoadData"
        >
          <template slot="empty">
            <img src="@/app-shared/assets/img/no-search.png" />
            <p>{{ $t('host.k_574003') }}</p>
          </template>
          <vh-table-column type="selection" width="55"></vh-table-column>
          <vh-table-column :label="$t('host.k_574004')">
            <template slot-scope="scope">
              <span class="mediaName" :title="scope.row.title">
                {{ scope.row.title }}
              </span>
            </template>
          </vh-table-column>
          <vh-table-column
            prop="total_score"
            :label="$t('host.k_574005')"
            width="80"
          ></vh-table-column>
          <vh-table-column
            prop="questions_count"
            :label="$t('host.k_574006')"
            width="90"
          ></vh-table-column>
          <vh-table-column :label="$t('host.k_574007')" width="105">
            <template slot-scope="scope">
              <span>
                {{
                  scope.row.limit_time_switch > 0
                    ? limitTime(
                        scope.row.limit_time * (scope.row.limit_time_type == 1 ? 1000 : 60 * 1000)
                      )
                    : $t('host.k_574008')
                }}
              </span>
            </template>
          </vh-table-column>
          <vh-table-column width="100" :label="$t('host.k_574009')">
            <template slot-scope="scope">
              <span class="show-hover" style="cursor: pointer" @click="preview(scope.row)">
                {{ $t('host.k_574010') }}
              </span>
            </template>
          </vh-table-column>
        </vh-table>
      </div>
      <div class="no-exam" v-show="noExamData">
        <span class="null-img"><img src="../../img/no-file.png" alt="" /></span>
        <p>{{ $t('host.k_574011') }}</p>
      </div>

      <div v-show="!noExamData" slot="footer" class="exam-num">
        <p class="text">
          <i18n path="host.k_574012">
            <template>
              <span>{{ checkList.length }}</span>
            </template>
          </i18n>
        </p>
        <div>
          <vh-button
            round
            size="medium"
            type="primary"
            @click.prevent.stop="choseSureExam"
            :disabled="!checkList.length"
            v-preventReClick
          >
            {{ $t('host.k_574013') }}
          </vh-button>
          <vh-button plain round size="medium" @click.prevent.stop="handleClose">
            {{ $t('host.k_574014') }}
          </vh-button>
        </div>
      </div>
    </vh-dialog>
    <!-- 预览快问快答 -->
    <exam-prev ref="examPrevDialog" maxWidth="580px" maxHeight="420px"></exam-prev>
  </div>
</template>
<script>
  import examPrev from '@/packages/exam/src/components/exam-prev.vue';
  import noExamDataImg from '../../img/no-file.png';
  import { limitTime } from '@/app-shared/utils/handle-time.js';
  export default {
    name: 'materialExamSelect',
    inject: ['examServer'],
    props: {
      checkedExamList: {
        type: Array,
        default: () => {}
      }
    },
    data() {
      return {
        vm: null,
        total: 0,
        dialogVisible: false,
        loading: false,
        checkList: [],
        examList: [],
        examIdList: [],
        isCheckAll: false,
        keywordIpt: '',
        queryParams: {
          limit: 10,
          keyword: '',
          pageNum: 1
        },
        noExamDataImg
      };
    },
    components: {
      examPrev
    },
    computed: {
      // 暂未创建列表
      noExamData() {
        return this.queryParams.keyword === '' && this.total === 0;
      }
    },
    methods: {
      limitTime(val) {
        return limitTime(val);
      },
      open(list) {
        this.dialogVisible = true;
        this.keywordIpt = '';
        this.isCheckAll = false;
        this.examList = [];
        this.checkList = list || []; // 清空选中列表
        this.examIdList =
          (this.checkedExamList.length && this.checkedExamList.map(item => Number(item.id))) || [];
        this.getExamList();
      },
      getExamList(clear = true) {
        console.log('getExamList');
        this.queryParams.pageNum = 1;
        if (clear) {
          this.keywordIpt = '';
        }
        this.examList = [];
        this.queryExamList();
      },
      queryExamList() {
        const keywords = (this.queryParams.keyword = this.keywordIpt);
        const params = {
          limit: this.queryParams.limit,
          exclude_ids: (this.examIdList.length && this.examIdList.join(',')) || '',
          pos: (this.queryParams.pageNum - 1) * this.queryParams.limit,
          keywords,
          sort_field: 'paper_edit_time'
        };
        this.examServer.getExamList(params).then(res => {
          this.examList.push(...res.data.list);
          // this.examList = res.data.list;
          // res.data.list.map(item => {
          //   this.examList.push(item);
          // });
          if (this.isCheckAll) {
            this.$refs.selectExamTable.toggleAllSelection();
          }
          this.total = res.data.total;
          // if (res.data.total) {
          //   this.checkList = JSON.parse(JSON.stringify(this.checkedExamList || []));
          //   this.selectedDefaultList(this.checkedExamList);
          // }
        });
      },
      moreLoadData() {
        if (this.examList.length >= this.total) return false;
        this.queryParams.pageNum++;
        this.queryExamList();
      },
      //文案提示问题
      messageInfo(msg, type) {
        if (this.vm) {
          this.vm.close();
        }
        this.vm = this.$message({
          showClose: true,
          duration: 2000,
          message: msg,
          type: type,
          customClass: 'zdy-info-box'
        });
      },
      handleClose() {
        this.dialogVisible = false;
        this.checkList = [];
      },
      // 选择资料库中的快问快答
      choseSureExam() {
        if (this.examIdList.length + this.checkList.length > 100) {
          this.messageInfo(this.$t('host.k_574015'), 'error');
          return;
        }
        this.$emit('checkExam', this.checkList);
        this.handleClose();
      },
      selectedDefaultList(list) {
        this.$nextTick(() => {
          if (list.length) {
            let selectedList = [];
            selectedList = list.map(item => {
              return item.id;
            });
            // 如果返回的列表已经选过，就默认选中
            this.examList.forEach(item => {
              if (selectedList.includes(item.id)) {
                this.$nextTick(() => {
                  this.$refs.selectExamTable.toggleRowSelection(item, true);
                });
              }
            });
          }
        });
      },
      // 预览
      preview(examObj) {
        this.$refs.examPrevDialog && this.$refs.examPrevDialog.open(examObj.id, examObj.title);
      },
      checkAllExam(selection) {
        // 全选
        this.isCheckAll = selection && selection.length > 0;
        this.checkList = selection;
        // this.checkList = selection.map(item => item.id);
      },
      // 选中
      handleSelectionChange(val) {
        this.checkList = val;
        // this.checkList = val.map(item => item.id);
      }
    }
  };
</script>
<style lang="less">
  .setting-checked-dialog {
    .search-dialog-tag {
      .vh-input__icon {
        line-height: 36px;
      }
      .vh-input__inner {
        border-radius: 20px;
        height: 36px;
        padding-right: 30px !important;
        border-radius: 18px;
      }
      .vh-input__prefix {
        cursor: pointer;
      }
    }
    .data-base-list {
      width: 100%;
      margin: 16px 0 20px 0;
      .mediaName {
        font-size: 14px;
        color: #1a1a1a;
        width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .vh-table th {
        background-color: #f7f7f7;
      }
      .show-hover {
        &:hover {
          color: #fb3a32;
        }
      }
    }
    .exam-num {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    .text {
      font-size: 14px;
      padding-left: 12px;
      span {
        color: #fb3a32;
        padding: 0 5px;
      }
      .vh-table th {
        background: #f7f7f7;
        padding: 15px 0;
      }
      .vh-table td {
        padding: 15px 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      span {
        cursor: pointer;
      }
    }
    .dialog-footer {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      padding: 0 0;
    }
    .no-exam {
      height: 360px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      .null-img {
        display: inline-block;
        width: 80px;
        height: 80px;
        img {
          width: 100%;
          height: 100%;
          object-fit: scale-down;
        }
      }
      p {
        font-size: 14px;
        padding: 10px 0;
      }
    }
    .cursor-pointer {
      color: #8c8c8c;
      cursor: pointer;
      &:hover {
        color: #595959;
      }
    }
  }
</style>
